export default {
  header: "Ravi de vous recontrer",
  title1: "Je suis",
  title2: 'Julien Souki-Léon',
  subtitle: "Développeur full-stack",
  link1: 'Apprennez à me connaître',
  link2: 'Envoyez-moi un message',
};
